import { useLang } from "@/lib/lang";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const { t, dir } = useLang();
  const row = t.marquee.map((m, i) => (
    <span key={i} className="flex items-center gap-10 pe-10 md:gap-16 md:pe-16">
      <span className="font-display italic text-[clamp(2.2rem,5vw,4.4rem)] leading-none text-[var(--ink)] whitespace-nowrap" dir={dir}>{m}</span>
      <LogoMark className="h-7 w-7 shrink-0 text-[var(--brass)]" />
    </span>
  ));
  return (
    <section className="relative border-y border-[var(--line)] bg-[#F2F9F9] py-8 md:py-10 overflow-hidden" data-testid="editorial-marquee" aria-label="Highlights">
      <div className="flex w-max animate-marquee" dir="ltr">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </section>
  );
};
